export default __webpack_public_path__ + "static/media/bg-home.4d0a4048.png";